const CONTENT = [{
    "type": "page",
    "name": "页面",
    "id": "0",
    "prop": {
        "backgroundColor": "#eee",
        "title": "自定义页面",
        "desc": "描述",
        "name": "第一个自定义页面",
        "keyWord": "喜鹊",
        "attentionBar": "1",
        "floatBtn": "1",
        "search": "1",
        "tabbar": "1",
        "backBtn": "1",
        "cover": ""
    }
}, {
    "type": "slider",
    "name": "轮播图",
    "parent": "base",
    "icon": "shoucang",
    "prop": {
        "btnPosition": "right",
        "btnShape": "circle",
        "btnMarginLR": 5,
        "btnMarginB": 5,
        "btnColor": "#17B3A3",
        "opacity": 1
    },
    "data": [{
        "url": "http://wx.you73.top/addons/ewei_shopv2/plugin/diypage/static/images/default/banner-1.jpg",
        "action": ""
    }, {
        "url": "http://wx.you73.top/addons/ewei_shopv2/plugin/diypage/static/images/default/banner-2.jpg",
        "action": ""
    }],
    "id": "54183363-ea9d-4b20-8482-c320b949f22f"
}, {
    "type": "goodsList",
    "name": "商品列表",
    "parent": "base",
    "icon": "shezhi",
    "prop": {
        "listStyle": "12",
        "backgroundColor": "#fff",
        "nameShow": "0",
        "nameColor": "#666",
        "priceShow": "0",
        "priceColor": "#666",
        "btnType": "5",
        "btnColor": "#ff0000",
        "iconType": "2",
        "iconColor": "#ff0000",
        "iconAttr": "热销"
    },
    "data": [{
        "classify": "1",
        "content": "1",
        "costPrice": 1,
        "id": 1,
        "images": "http://wx.you73.top/addons/ewei_shopv2/plugin/diypage/static/images/default/goods-1.jpg",
        "number": 1,
        "originalPrice": 1,
        "productCode": "1",
        "productName": "1",
        "specialPrice": 1,
        "standard": "1",
        "state": "1",
        "uuid": "1",
        "vipPrice": 1
    }, {
        "classify": "1",
        "content": "1",
        "costPrice": 1,
        "id": 1,
        "images": "http://wx.you73.top/addons/ewei_shopv2/plugin/diypage/static/images/default/goods-4.jpg",
        "number": 1,
        "originalPrice": 1,
        "productCode": "1",
        "productName": "1",
        "specialPrice": 1,
        "standard": "1",
        "state": "1",
        "uuid": "1",
        "vipPrice": 1
    }, {
        "classify": "1",
        "content": "1",
        "costPrice": 1,
        "id": 1,
        "images": "http://wx.you73.top/addons/ewei_shopv2/plugin/diypage/static/images/default/goods-2.jpg",
        "number": 1,
        "originalPrice": 1,
        "productCode": "1",
        "productName": "1",
        "specialPrice": 1,
        "standard": "1",
        "state": "1",
        "uuid": "1",
        "vipPrice": 1
    }, {
        "classify": "1",
        "content": "1",
        "costPrice": 1,
        "id": 1,
        "images": "http://wx.you73.top/addons/ewei_shopv2/plugin/diypage/static/images/default/goods-3.jpg",
        "number": 1,
        "originalPrice": 1,
        "productCode": "1",
        "productName": "1",
        "specialPrice": 1,
        "standard": "1",
        "state": "1",
        "uuid": "1",
        "vipPrice": 1
    }],
    "id": "7e070c74-68ab-464e-8d76-d5dab71b6738"
}, {
    "type": "richText",
    "name": "富文本",
    "parent": "base",
    "icon": "tubiao",
    "prop": {
        "backgroundColor": "#ff0000",
        "padding": 10
    },
    "data": "<p>测试<span style=\"font-size: 24px;\">测试</span><span style=\"text-decoration: line-through; font-size: 16px;\">测试</span><span style=\"font-size: 16px; text-decoration: underline;\">测试</span><em><span style=\"font-size: 16px; text-decoration: none;\">测试</span></em></p><p><strong><span style=\"font-size: 16px; text-decoration: none;\">测试</span></strong><span style=\"font-size: 16px; text-decoration: none;\">测试<sup>2</sup><span style=\"font-size: 16px; text-decoration: none; color: rgb(149, 55, 52);\">测试</span><span style=\"font-size: 16px; text-decoration: none; background-color: rgb(247, 150, 70);\">测试</span></span></p><p><span style=\"font-size: 16px; text-decoration: none;\"><span style=\"font-size: 16px; text-decoration: none; background-color: rgb(247, 150, 70);\"></span></span></p><p style=\"text-align: center;\"><span style=\"font-size: 16px; text-decoration: none;\">测试</span></p><p style=\"text-align: right;\"><span style=\"font-size: 16px; text-decoration: none;\">测试</span></p><p style=\"text-align: left;\"><span style=\"font-size: 16px; text-decoration: none;\"><img src=\"http://img.baidu.com/hi/tsj/t_0027.gif\"/><img src=\"http://img.baidu.com/hi/bobo/B_0006.gif\"/></span></p>",
    "id": "408c1438-2349-4e8f-8d3a-74b44f2f6dd0"
}]
export default {
    namespaced: true,
    state: {
        components: CONTENT,
        shopId: undefined,
        titleName: '',
        list:[],
        numList:[],
        imgList:[],
        pic:[],
    },
    getters: {

    },
    actions: {
        increment(context) {
            context.commit('increment')
        }
    },
    mutations: {
        setShopId(state, shopId) {
            state.shopId = shopId
        },
        setTitleName(state, titleName) {
        
            state.titleName = titleName
        },

    },
}


// WEBPACK FOOTER //
// ./src/store/modules/designer.js